<template>
  <div id="BMIListPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="ثبت BMI (شاخص توده بدنی)"></ActionBar>
    <div v-if="isLoaded" class="row container mx-auto no-gutters p-0 mt-2">
      <div v-if="!hasRegistered" class="row mx-2 mt-10 knowledge-base-body">
        <div class="col-12">
          <v-alert
              border="bottom"
              class="mt-4 text-center"
              color="primary"
              dark>
            این اطلاعات ماهی یکبار باید ثبت شود و شما در ماه جاری ثبت کرده اید.
          </v-alert>
        </div>
      </div>
      <div v-else class="col-12 rounded-b-lg header-rounded bg-white card-shadow">
        <div class="third-background header-rounded mb-3 white--text p-2"><span> </span></div>
        <div class="row mx-1">
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1 font-weight-bold">قد (سانتی متر):</span>
            <v-text-field
                v-model.number="height"
                class="mr-1 input-border gray-bg-input"
                dense
                hide-details
                solo>
            </v-text-field>
          </div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1 font-weight-bold">وزن (کیلوگرم):</span>
            <v-text-field
                v-model.number="weight"
                class="input-border gray-bg-input"
                dense
                hide-details
                solo>
            </v-text-field>
          </div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
              class="mt-1 font-weight-bold">توضیحات:</span>
            <v-textarea
                v-model="bmiDescription"
                class="input-border gray-bg-input "
                dense
                hide-details
                solo
                type="text">
            </v-textarea>
          </div>
          <div class="col-12 text-center mb-3">
            <v-btn :disabled="height === null || weight === null " class="px-10" color="forth"
                   rounded
                   @click="showConfirmDialog = true">
              <span class="white--text">ثبت</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showConfirmDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">لطفا از صحیح بودن موارد وارد شده اطمینان حاصل نمایید!</div>
          <div class="mb-0 black--text font12px">در صورت ثبت امکان تغییر آن وجود ندارد.</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="forth" rounded @click="showConfirmDialog = !showConfirmDialog">
            <span class="white--text">بستن</span>
          </v-btn>
          <v-btn class="px-8" color="primary" rounded @click="registerBMI">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";
import moment from "moment-jalaali";


export default {
  name: "BMI",
  metaInfo: {
    title: 'مسیربرتر-ثبت BMI (شاخص توده بدنی)'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    height: null,
    weight: null,
    bmiDescription: null,
    dialogResult: null,
    showResultDialog: false,
    showLoaderDialog: false,
    showConfirmDialog: false,
    hasRegistered: true,
    isLoaded: false
  }),
  mounted() {
    _this = this
    this.getBMIHistory()
  },
  methods: {
    registerBMI() {

      this.showConfirmDialog = false;
      this.showLoaderDialog = true;

      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("Weight", this.$convertFarsiNumber(this.weight));
      urlencoded.append("Height", this.$convertFarsiNumber(this.height));
      urlencoded.append("Description", this.bmiDescription);
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Dashboard/SetBmi", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.dialogResult = result;
            _this.showResultDialog = true
            this.getBMIHistory()
          })
          .catch(error => console.log('error', error));
    },
    getBMIHistory() {
      this.showLoaderDialog = true
      let currentDate = new Date()
      let m = moment(currentDate)
      m.format('jYYYY/jMM/jDD')
      let month = (m.format('jMM'))
      let year = m.format('jYYYY')
      let jalaliEndDate = null
      let jalaliStartDate = year + '/' + month + '/' + '01'
      if (month >= 1 && month <= 6) {
        jalaliEndDate = year + '/' + month + '/' + '31'
      } else {
        jalaliEndDate = year + '/' + month + '/' + '30'

      }
      // let startDate = this.$convertDateToMiladi(jalaliStartDate)
      // let endDate = this.$convertDateToMiladi(jalaliEndDate)

      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", jalaliStartDate);
      urlencoded.append("EndDate", jalaliEndDate);
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);

      /*for (const [key, value] of urlencoded.entries()) {

      }*/
      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_Bmi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              _this.hasRegistered = false
            }
            _this.showLoaderDialog = false
            _this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>